export enum POSReduxActions {
  SET_BILLINGS = "SET_BILLINGS",
  SET_ACTIVE_BILL = "SET_ACTIVE_BILL",
}

const setBills = (payload: any): any => ({
  type: POSReduxActions.SET_BILLINGS,
  payload,
});

const setActiveBill = (payload: any): any => ({
  type: POSReduxActions.SET_ACTIVE_BILL,
  payload,
});

export const POSActions = {
  setBills,
  setActiveBill,
};
